import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this really for absolute beginners with no prior health knowledge?',
  a: 'Yes. The system is written in simple English, completely free of dense medical jargon. We begin with the basic biological shifts and build everything step by step into an actionable daily routine.'
}, {
  q: 'Do I need to buy expensive exotic foods or rare supplements?',
  a: 'Not at all. Everything recommended inside the protocol can be easily found at your local grocery store or health shop. We believe in practical, accessible wellness.'
}, {
  q: 'Are the bonus templates printable?',
  a: 'Yes! All tracking sheets, recipe guides, and checklists are designed in high-resolution PDF format, ready to be printed or used digitally on your smartphone, tablet, or computer.'
}, {
  q: 'How soon will I see real results in my symptoms?',
  a: 'While every body is unique, most women report a significant improvement in sleep quality and a reduction in daytime hot flashes within the first 5 to 7 days of starting the protocol.'
}, {
  q: 'Is there any recurring monthly subscription?',
  a: 'No. This is a strict one-time payment of $27. You get lifetime access to the entire bundle, including all future updates and expansions for free.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-56" data-mp="11v5s678qrp1s">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-57" data-mp="16picsklyf6f4">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-58" data-mp="s0vzeofw0oqj">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-59" data-mp="iymnpv8vupbk">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-60" data-mp="2pmn41ucr1rz3" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-61" data-mp="2pmwxxt0x0ja2">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-62" data-mp="2ayihugehmybk">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-63" data-mp="38lraqwgtj9nl" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-64" data-mp="38jesei75exa0" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-65" data-mp="33kbncxr64r21">
                  <div className="overflow-hidden" data-id="element-66" data-mp="2ukycq1rb5wfq">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-67" data-mp="1n86ezjy3nrru">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}